import { useAppDispatch } from "../../../app/hooks";
import { Button } from "@hatch-digital-nl/bravilor-storybook";
import { ProductFilterWrapper } from "./ProductFilterWrapper";
import { resetFilter } from "../../../pages/productRangePage/ProductRangeSlice";
import { SvgReset } from "../../svgs/SvgReset";
import { FilterListInterface } from "../../interfaces/FilterListInterface";
import { JSX } from "react";

const hasActiveFilters = (selectedFilters: {
    [filterId: string]: {
        id: number;
        options: { id: string; value: string | number }[];
    };
}): boolean => {
    return (
        Object.keys(selectedFilters).length > 0 &&
        Object.values(selectedFilters).some(
            (filter) => filter.options.length > 0,
        )
    );
};

export const Filters = ({
    filters,
    selectedFilters,
    onClose,
    mobileFiltersActive,
}: {
    filters: FilterListInterface[];
    selectedFilters: {
        [filterId: string]: {
            id: number;
            options: { id: string; value: string | number }[];
        };
    };
    onClose: () => void;
    mobileFiltersActive: boolean;
}): JSX.Element => {
    const dispatch = useAppDispatch();
    const isFiltersActive = hasActiveFilters(selectedFilters);

    return (
        <div
            className={
                "c-product-filters " + (mobileFiltersActive ? "is-active" : "")
            }
        >
            <div className="c-product-filters__header">
                <h2>Filters</h2>
                <Button
                    variant={"secondary"}
                    onClick={onClose}
                    className="c-product-filters__close c-product-filters__close--square"
                >
                    <svg
                        fill="#000000"
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z"
                            fillRule="evenodd"
                        />
                    </svg>
                </Button>
            </div>

            <div className="c-product-filters__container">
                {filters.map((filter, index) => (
                    <ProductFilterWrapper
                        key={index}
                        filter={filter}
                        index={index}
                    />
                ))}

                <div className="c-product-filters__btn-reset__container">
                    <Button
                        variant={`${isFiltersActive ? "primary" : "secondary"}`}
                        onClick={() => dispatch(resetFilter())}
                        className={`c-product-filters__btn-reset ${isFiltersActive ? "c-product-filters__btn-reset--active" : ""}`}
                    >
                        <SvgReset color={isFiltersActive ? "white" : "black"} />
                        <span>Reset filters</span>
                    </Button>
                </div>

                <div
                    className="c-product-filters__mobile-footer"
                    onClick={onClose}
                >
                    <Button variant={"secondary"}>Filter results</Button>
                </div>
            </div>
        </div>
    );
};
